import {DefaultSettings, settings} from '../../../settings/settings-util';
import reducer from './reducers';
import UI from './handlers/ui';
import ResponseHandler from './handlers/response-handler';
import GetHistoryResponseHandler from './handlers/gethistory-response-handler';
import ErrorResponseHandler from "./handlers/error-response-handler";
import {Reducer, Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
import LiveChatState from "./livechat-state";
import LiveChatRetriever from "./livechat-retriever";
import LiveChatPoller from "./livechat-poller";
import HistoryAppender from "./handlers/history-appender";


export default class LiveChat
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _errorResponseHandler: ErrorResponseHandler;
    _historyAppender: HistoryAppender
    _state: LiveChatState;
    _ui: UI;
    _responseHandler: ResponseHandler;
    _getHistoryResponseHandler: GetHistoryResponseHandler;
    _retriever: LiveChatRetriever;
    _poller: LiveChatPoller


    //#region Public Interface

    constructor(passedSettings: DefaultSettings = settings)
    {
        this._settings = passedSettings;

        this._state = new LiveChatState(this._settings);
        this._errorResponseHandler = new ErrorResponseHandler(this._settings, this._state);
        this._historyAppender = new HistoryAppender(this._settings, this._state);

        this._ui = new UI(this._settings, this._state);
        this._responseHandler = new ResponseHandler(this._settings, this._state);
        this._getHistoryResponseHandler = new GetHistoryResponseHandler(this._settings, this._state);

        this._retriever = new LiveChatRetriever(this._settings, this._state);
        this._poller = new LiveChatPoller(this._settings, this._retriever, this._state);
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
        this._historyAppender.initialize(store);
        this._ui.initialize(store);
        this._state.initialize(store);
        this._responseHandler.initialize(store);
        this._getHistoryResponseHandler.initialize(store);
        this._errorResponseHandler.initialize(store);
        this._retriever.initialize(store);
        this._poller.initialize(store);
    }

    getReducer(): Reducer<AlmeState>
    {
        return reducer;
    }

    get UI(): UI { return this._ui; }

    get ResponseHandler(): ResponseHandler { return this._responseHandler; }

    get GetHistoryResponseHandler(): GetHistoryResponseHandler { return this._getHistoryResponseHandler; }

    get ErrorResponseHandler(): ErrorResponseHandler { return this._errorResponseHandler; }

    get Poller(): LiveChatPoller { return this._poller; }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/livechat.ts